import { NavItem } from '../../shared/models/nav-item.model';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', route: '/dashboard', icon: 'layout-dashboard', enabled: true },
  { label: 'Submissions', route: '/submissions', icon: 'clipboard-check', enabled: true },
  { label: 'Raffle Draw', route: '/raffle', icon: 'ticket', enabled: true },
  { label: 'Reports', route: '/reports', icon: 'bar-chart-3', enabled: true },
];
